import { useMutation } from '@tanstack/react-query';
import { generateInvoices } from '../Services/InvoiceService';

const useGenerateInvoices = (options = {}) => useMutation(generateInvoices, options);

export default useGenerateInvoices;
